import { Card } from "@prismicio/editor-ui"
import { forwardRef, type ReactNode } from "react"

import { type MediaAssetOrExternalImage } from "../../../core/MediaLibrary/hooks/mediaLibraryData"
import { MediaDialog } from "../MediaDialog"

interface ImageFieldCardProps {
  isMediaDialogOpen: boolean
  selected?: boolean
  children: ReactNode
  onMediaDialogOpenChange: (open: boolean) => void
  onMediaSelected: (media: MediaAssetOrExternalImage) => void
}

export const ImageFieldCard = forwardRef<HTMLDivElement, ImageFieldCardProps>(
  function ImageFieldCard(props, ref) {
    const {
      isMediaDialogOpen,
      selected,
      children,
      onMediaSelected,
      onMediaDialogOpenChange,
    } = props

    function handleMediaSelected(media: MediaAssetOrExternalImage) {
      onMediaSelected(media)
      onMediaDialogOpenChange(false)
    }

    return (
      <Card
        ref={ref}
        color={selected ? "indigo2" : "grey2"}
        variant={selected ? "selected" : "dashed"}
        paddingBlock={12}
        radius={4}
      >
        {children}

        <MediaDialog
          open={isMediaDialogOpen}
          onOpenChange={onMediaDialogOpenChange}
          onMediaSelected={handleMediaSelected}
          assetType="image"
        />
      </Card>
    )
  },
)
